export * from './inscribirse/inscribirse.component';
export * from './tiene-usuario-yrepro/tiene-usuario-yrepro.component';
export * from './derivaciones/derivaciones.component';
export * from './confirmar-usuario-clave/confirmar-usuario-clave.component';
export * from './menu-principal/menu-principal.component';
export * from './pacientes/pacientes.component';